// components/ToolIcon.jsx
import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { ToolIconMap } from "./ToolIconMap";

const ToolIcon = ({ name, size = 24, color = "inherit", onClick, sx }) => {
  const iconSrc = ToolIconMap[name.toLowerCase()];

  if (!iconSrc) return null;

  return (
    <Box
      component="img"
      src={iconSrc}
      alt={name}
      onClick={onClick}
      sx={{
        width: size,
        height: size,
        cursor: onClick ? "pointer" : "default",
        filter: color !== "inherit" ? `brightness(0) saturate(100%) ${color}` : "none",
        ...sx,
      }}
    />
  );
};

ToolIcon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
  color: PropTypes.string,
  onClick: PropTypes.func,
  sx: PropTypes.object,
};

export default ToolIcon;
